module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/library-f69427b6bf18e58eeffac83caa3d1c79.svg";